var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.posts),function(post){return _c('CataloguePost',{key:post.post_id,attrs:{"post":post}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }